module.exports = __webpack_public_path__ + "img/icon-phone-2.1d1a85c0.png";